module.exports = __webpack_public_path__ + "img/Participa-phone-1.e9f57d6a.png";